var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flash",
    style: {
      backgroundColor: _vm.backgroundColor
    }
  }, [_c('div', {
    staticClass: "flash__bg flash__bg_desktop"
  }, [_vm.backgroundDesktop ? [_vm.backgroundDesktop.includes('.mp4') || _vm.backgroundDesktop.includes('.webm') ? _c('video', {
    staticClass: "flash__bg_video",
    attrs: {
      "src": _vm.backgroundDesktop,
      "loop": "",
      "muted": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    staticClass: "flash__bg_img",
    attrs: {
      "src": _vm.backgroundDesktop
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "flash__bg flash__bg_mobile"
  }, [_vm.backgroundMobile ? [_vm.backgroundMobile.includes('.mp4') || _vm.backgroundMobile.includes('.webm') ? _c('video', {
    staticClass: "flash__bg_video",
    attrs: {
      "src": _vm.backgroundMobile,
      "loop": "",
      "muted": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    staticClass: "flash__bg_img",
    attrs: {
      "src": _vm.backgroundMobile
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "flash__main"
  }, [_c('img', {
    staticClass: "flash__lightning",
    attrs: {
      "src": require("./asset/lightning.svg"),
      "alt": "lightning"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flash__info"
  }, [_vm.title ? _c('h1', {
    staticClass: "flash__title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm.subtitle ? _c('p', {
    staticClass: "flash__subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), _vm.timerDate ? _c('GGTimerBlock', {
    staticClass: "flash__timer",
    attrs: {
      "size": _vm.timerSize,
      "color": _vm.timerColor,
      "time": _vm.timerDate
    }
  }) : _vm._e(), _vm._v(" "), _vm.linkText && _vm.link ? _c('GGLink', {
    staticClass: "flash__link",
    attrs: {
      "to": _vm.link
    }
  }, [_vm._v(_vm._s(_vm.linkText))]) : _vm._e()], 1)]), _vm._v(" "), _c('ViewportToogle', {
    staticClass: "flash__products",
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return [_c('GGProductFlashGrid', {
          attrs: {
            "items": _vm.data.dataSource.data.product || []
          },
          on: {
            "cart-add": function ($event) {
              return _vm.$emit('cart-add', $event);
            },
            "cart-remove": function ($event) {
              return _vm.$emit('cart-remove', $event);
            }
          }
        })];
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('GGRowSlider', {
          attrs: {
            "list": _vm.data.dataSource.data.product || [],
            "offset-between-elements": 5
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref) {
              var _el$price;

              var el = _ref.el;
              return [_c('GGLink', {
                staticClass: "product",
                attrs: {
                  "to": el.path
                }
              }, [_c('div', {
                staticClass: "product__wrap-img"
              }, [_c('img', {
                staticClass: "product__img",
                attrs: {
                  "src": el.image.x1,
                  "srcset": ((el.image.x2) + " 2x"),
                  "alt": el.name
                }
              })]), _vm._v(" "), el.name ? _c('div', {
                staticClass: "product__title"
              }, [_vm._v("\n            " + _vm._s(el.name) + "\n          ")]) : _vm._e(), _vm._v(" "), (_el$price = el.price) !== null && _el$price !== void 0 && _el$price.common.value ? _c('GGPrice', {
                staticClass: "product__price",
                attrs: {
                  "price": el.price
                }
              }) : _vm._e()], 1)];
            }
          }])
        })];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }